import { Box, CardContent, CardHeader, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import theme from 'theme'

export const WhatIsAReliabilityTest: React.FC = () => {
  return (
    <Box data-testid="what-is-a-reliability-test">
      <CardHeader
        title={
          <Typography variant="h6">
            What is a Reliability Test?{' '}
            <Link
              target="_blank"
              to="https://www.gremlin.com/blog/four-reliability-tests/"
            >
              <Icon
                css={{ fontSize: theme.fontSizes[2] }}
                icon="arrowUpRightFromSquare"
              />
            </Link>
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body2">
          Each defined Service will have 4 Reliability Tests to go through.
          Additionally, Gremlin will want to look at your Service's dependencies
          to see if dependency failure or latency impact that defined Service.
        </Typography>
      </CardContent>
    </Box>
  )
}
